import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/app/[hostname]/loading.tsx");
